// extracted by mini-css-extract-plugin
export default {"advertCardList":"c-a_hl","advertCardList_max6":"c-a_hm"};